import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon MouseIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const MouseIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 33 20">
      <g>
        <g id="Layer_1">
          <path d="M28.35,7.69c.7-1.03,1.3-2.8.32-4.77-.58-1.17-1.69-2.07-3.04-2.46-1.49-.43-3.1-.2-4.52.65-1.03.62-1.68,1.51-1.88,2.59-.02.09-.03.19-.04.28-3.26-.22-6.96-.13-10.1,1.87-3.58,2.28-5.09,5.73-4.97,7.98.02.34.09.64.18.93-1.92.27-4.05,1.1-4.05,2.77,0,2.45,2.16,2.45,5.42,2.45.41,0,.75-.34.75-.75s-.34-.75-.75-.75c-3.92,0-3.92-.26-3.92-.95s2.02-1.37,3.92-1.37h24.96s.1.01.16.01c.19,0,.41-.05.67-.21.45-.28,1.3-1.1,1.3-1.82s-2.84-4.8-4.4-6.44ZM30.7,14.65h-12.41c.59-.97.72-1.86.68-2.52-.07-1.32-.79-2.56-2.02-3.48-.33-.25-.8-.18-1.05.15-.25.33-.18.8.15,1.05.87.65,1.37,1.49,1.42,2.36.04.83-.34,1.66-1.09,2.44H5.9c-.16-.16-.26-.49-.28-.9-.08-1.52,1-4.54,4.28-6.63,2.84-1.81,6.33-1.85,9.39-1.63.21.92.65,1.75,1.08,2.3.25.33.72.39,1.05.13.33-.25.39-.73.13-1.05-.56-.71-1.03-1.89-.84-2.9.12-.66.51-1.17,1.18-1.58,1.06-.64,2.25-.81,3.33-.5.94.27,1.71.89,2.11,1.69.83,1.66.03,3.09-.51,3.62,0,0-.01.01-.02.02-.62.6-1.04.78-1.8.78-.41,0-.75.34-.75.75s.34.75.75.75c.92,0,1.62-.22,2.32-.75,1.27,1.3,3.37,4.49,3.87,5.4-.12.17-.34.4-.49.5Z" />
        </g>
      </g>
    </Icon>
  )
}
export default MouseIcon
